import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import VueMobileDetection from 'vue-mobile-detection'

createApp(App).use(store).use(router).use(VueMobileDetection).mount('#app')
